export default __webpack_public_path__ + "static/media/absolute-3.6d75c353.png";